import { Autocomplete, TextField, useMediaQuery } from '@mui/material';
import EmptyCell from 'components/EmptyCell';
import { useChallengeContextContext } from 'context/ChallengeContext/ChallengeContext';
import React from 'react';
import { EditorProps } from 'react-data-grid';

export function WorkoutsAutoComplteComponent<TRow, TSummaryRow>({
  row,
  column,
  onRowChange,
  onClose,
}: EditorProps<TRow, TSummaryRow>) {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const { workoutsAutoComplete } = useChallengeContextContext();

  const onChangeValue = (value: Workout | null) => {
    onRowChange(
      {
        ...row,
        [column.key]: value?.name,
        workout_id: value?.id,
        part: value?.part?.name || '',
      },
      true,
    );
    onClose();
  };

  if ((row as any).name === 'isRest') {
    return <EmptyCell />;
  }

  return (
    <Autocomplete
      autoSelect
      autoHighlight
      getOptionLabel={(option) => option.name}
      groupBy={(option) => option.part.name}
      // value={row[column.key as keyof TRow] as unknown as string}
      sx={{ width: '100%', flex: 1 }}
      freeSolo
      options={[
        ...new Set(
          workoutsAutoComplete.sort((a, b) => -b.name.localeCompare(a.name)),
        ),
      ]}
      onChange={(_, value) => onChangeValue(value as Workout)}
      renderInput={(params) => (
        <TextField
          sx={{ input: { color: prefersDarkMode ? 'white' : 'black' } }}
          autoFocus
          {...params}
          size='small'
          type='text'
          placeholder='운동명'
        />
      )}
    />
  );
}
